import Tree from "../../../components/main-view/WorkManagementInfo/Tree";
import stateManager from "./stateManager";

const TreeContainer = WrappedComponent => props => {
  const newProps = stateManager();
  return <WrappedComponent {...props} {...newProps} />;
};

export default TreeContainer(Tree);
